import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

const AddSocialLinkForm = ({
  fields,
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  title,
}) => {
  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>{title}</HeadingOne>}
    >
      {fields.map((field) => {
        if (field.type === "file") {
          return (
            <FormInputFile
              key={field.name}
              field={field}
              handleChange={handleFileChange}
              error={errors[field.name]}
            />
          );
        }

        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label="Add Social Link"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default AddSocialLinkForm;
